import React from 'react';
import KickImage from 'Reuseables/KickImage';
import InfoSection from './Info';
import FooterSection from './Footer';
import { withRouter } from "react-router-dom"

/* UTILS | HELPERS */
import {
  PAYMENT_LOGOS
} from "../../../../../constants/paymentMethods"
import {
  getCloudImageUrl,
  capitalizeFirstLetter,
  convertToRupiah
} from "../../../../../utils"
import { parse } from 'path';
import {
  renderMessage,
  getHeaderText,
  getStatusIcon,
  getSelectedPayment
} from "../paymentHelpers"

/* COMPONENTS */
import SuccessResult from "../SuccessResult"
import FailedResult from "../FailedResult"
import PendingResult from "../PendingResult"

/* ASSETS */
import ContinueArrow from "../../../../../images/shopping-cart-continue.png";
import PendingIcon from '../../../../../images/stopwatch.png';
import ErrorIcon from '../../../../../images/stopwatch.png';
import TimesUpIcon from '../../../../../images/icons/times-up.png';
import SuccessIcon from '../../../../../images/icons/success.png';

const Atome = ({ data = [], onClick, expire, orderDetailsData, ...props }) => {
  const {
    invoice_number,
    status,
    expired,
    expiry,
    bank_code,
    payment_method,
    total_amount,
    total_adjusted_amount,
    invoice_url
  } = data

  const renderLeftSection = () => {
    const payment_logo = PAYMENT_LOGOS[`${payment_method}`]

    if (expired) {
      return <FailedResult
        header_text={getHeaderText(status, expired)}
        orderDetailsData={orderDetailsData}
      >
        {renderMessage(
          status,
          expired,
          null,
          null,
          expiry
        )}
      </FailedResult>
    }

    switch (status) {
      case "COMPLETE":
      case "COMPLETED":
        return <SuccessResult orderDetailsData={orderDetailsData} invoice_number={invoice_number} />
      case "PENDING":
        return (
          <PendingResult
            invoice_number={invoice_number}
            status={status}
            header_text={getHeaderText(status, expired)}
            status_icon={getStatusIcon(status, expired)}
            expiry={expiry}
            bank_code={bank_code}
            payment_logo={getCloudImageUrl(payment_logo)}
            handleExpire={() => null}
            payment_method_text={getSelectedPayment(payment_method, bank_code)}
            amount_to_be_paid={parseInt(total_adjusted_amount)}
            invoice_url={invoice_url}
            onSuccess={() => null}
            onPending={() => null}
            onError={() => null}
            onClose={() => null}
            snapToken={null}
            buttonText={"COMPLETE PAYMENT"}
            orderDetailsData={orderDetailsData}
          />
        )
      default:
        return (
          <FailedResult
            header_text={getHeaderText(status, expired)}
            orderDetailsData={orderDetailsData}
          >
            {renderMessage(
              status,
              expired,
              null,
              null,
              expiry
            )}
          </FailedResult>
        )
    }
  }
  return (
    <>
      {renderLeftSection()}
      {/* <div>
        <InfoSection invoice_url={data.invoice_url} />
        <FooterSection onClick={onClick} expire={expire} />
      </div> */}
    </>
  )
}
export default withRouter(Atome);
